<template>
  <q-btn class="btn btn-warning" icon="sms" @click="toggleChatForm()">
    <q-tooltip>{{ $t("order.tooltip.messageCom") }}</q-tooltip>
  </q-btn>
  
  <div class="tw-aside-tools-inner" v-if="showComSidePanel" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999;">
    <div class="card" style="position: fixed; top: 0; right: 0; width: 30vw; height: 100vh; overflow: auto; z-index: 10000;">
      <div class="card-header bg-white d-flex justify-content-between align-items-center" style="height: 50px">
        <div class="card-title mb-0">
          <span class="text-primary cursor-pointer">{{ $t("Messages et alertes") }}</span>
        </div>
        <span @click="closeSidePanel" class="cursor-pointer">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
              fill="currentColor"></rect>
            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor">
            </rect>
          </svg>
        </span>
      </div>
      <div class="card-body">
        <!-- Tabs -->
        <div class="row flex-start mb-3 justify-content-between flex-nowrap" style="gap: 10px">
          <q-btn 
            :label="$t('demand.tabs.message')" 
            @click="activeTab = 'MESSAGE'" 
            class="btn btn-sm w-100" 
            :class="activeTab === 'MESSAGE' ? 'btn-primary' : 'btn-outline-primary'" 
          />
          <!-- Add more tabs here in the future -->
        </div>
        <!-- Tab Content -->
        <div class="row">
          <div class="col-lg-12">
            <MessageTab 
              v-if="activeTab === 'MESSAGE'" 
              :subjects="subjectsList"
              :references="optionsReference"
              :reference="selectedReference"
              :recipients="recipientsList"
              @message-sent="onMessageSent"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import MessageTab from "@/components/communication/MessageTab.vue";
import { Options, Vue } from "vue-class-component";
import { mapActions, mapState } from "vuex";
import store from "@/store";

@Options({
  name: "Communication",
  components: {
    MessageTab,
  },
  computed: {
    ...mapState("messagingModule", ["subjects", "recipients"]),
  },
  created() {
    this.onloadData();
    this.onSearch();
  },
  methods: {
    ...mapActions("messagingModule", [
      "fetchSubjects",
      "fetchReferences",
      "fetchCReference",
      "fetchRecipients",
    ]),

    toggleChatForm() {
      this.showComSidePanel = true;
      this.activeTab = "MESSAGE";
      this.fetchRecipients();
      this.updateSelectedReference();
    },

    closeSidePanel() {
      this.showComSidePanel = false;
    },

    onMessageSent() {
      // Optionally close the panel after message is sent
      
    },

    updateSelectedReference() {
      const routeName = this.currentRoute.name;
      if (routeName === "order-edit") {
        this.selectedReference = this.searchOrder();
      } else if (routeName === "order") {
        this.selectedReference = this.searchOrders();
      } else {
        this.selectedReference = null;
      }
    },

    updateResultRows(res: any) {
      this.optionsRefrence = res;
    },

    onloadData() {
      this.fetchSubjects();
      this.fetchRecipients();
    },

    onSearch() {
      store.dispatch("demandModule/searchOfferPartyOrder", {
        callback: this.updateResultRows,
        offerFilter: {},
        filterParty: {},
        orderFilter: {},
      });
    },

    searchOrders() {
      const referenceList: any[] = [];
      for (const order of this.selectedSearchOrder) {
        const search = this.optionsRefrence.find(
          (item: any) => item.referenceorder === order.referenceorder
        );
        search ? referenceList.push(search) : referenceList.push(order);
      }
      return referenceList;
    },

    searchOrder() {
      const referenceList: any[] = [];
      const search = this.optionsRefrence.find(
        (item: any) => item.referenceorder === this.order.reference
      );
      const externalReference =
        this.order &&
        this.order.orderItems[0] &&
        this.order.orderItems[0].externalReference
          ? this.order.orderItems[0].externalReference
          : "";
      const order = {
        referenceorder: this.order?.reference,
        externalreference: externalReference,
      };
      search ? referenceList.push(search) : referenceList.push(order);
      return referenceList;
    },
  },
})
export default class Communication extends Vue {
  optionsRefrence: any[] = [];
  showComSidePanel = false;
  activeTab = "MESSAGE";
  selectedReference: any = null;

  get subjectsList() {
    return (this as any).subjects?.map((subject: any) => subject.id) || [];
  }

  get recipientsList() {
    return (this as any).recipients || [];
  }

  get optionsReference() {
    return this.optionsRefrence;
  }

  get order() {
    return store.state.orderModule.order ? store.state.orderModule.order : {};
  }

  get selectedSearchOrder() {
    return store.state.orderModule.selectedSearchOrderItem
      ? store.state.orderModule.selectedSearchOrderItem
      : [];
  }

  get currentRoute() {
    return this.$router.currentRoute.value;
  }
}
</script>
